'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ClassBundleModal = exports.ClassBundleModalUnwrapped = exports.mapDispatchToProps = exports.mapStateToProps = undefined;

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _reactIntl = require('react-intl');

var _reactRedux = require('react-redux');

var _Modal = require('decorators/Modal/Modal');

var _Modal2 = _interopRequireDefault(_Modal);

var _ApiError = require('components/Errors/ApiError');

var _bound = require('redux/saga/entities/bound');

var _multitrack = require('helpers/multitrack');

var _bundles = require('./bundles.saga');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var mapStateToProps = exports.mapStateToProps = function mapStateToProps(state) {
  return {
    purchaseError: _bound.purchaseClassBundle.error(state),
    purchaseLoading: _bound.purchaseClassBundle.loading(state)
  };
};

var mapDispatchToProps = exports.mapDispatchToProps = {
  purchaseAddOn: _bundles.purchaseAddOn
};

var BUNDLE_PURCHASE_REQUEST_ERR_CODE = 5371; // Generic bundle error. Ex: bundles service can't reach Stripe API
var BUNDLE_PURCHASE_CARD_ERR_CODE = 5372; // Raised when Stripe bounces a purchase

var ClassBundleModalUnwrapped = exports.ClassBundleModalUnwrapped = function (_React$Component) {
  (0, _inherits3.default)(ClassBundleModalUnwrapped, _React$Component);

  function ClassBundleModalUnwrapped(props) {
    (0, _classCallCheck3.default)(this, ClassBundleModalUnwrapped);

    var _this = (0, _possibleConstructorReturn3.default)(this, (ClassBundleModalUnwrapped.__proto__ || (0, _getPrototypeOf2.default)(ClassBundleModalUnwrapped)).call(this, props));

    _this.handleClick = _this.handleClick.bind(_this);
    return _this;
  }

  (0, _createClass3.default)(ClassBundleModalUnwrapped, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.trackEventCollector('Manage Add Ons - Review Selection');
    }
  }, {
    key: 'handleClick',
    value: function handleClick() {
      var _props = this.props,
          purchaseLoading = _props.purchaseLoading,
          localPurchaseAddOn = _props.purchaseAddOn,
          versionedBundleId = _props.versionedBundleId;

      // Ensures only one submission is in flight. ie. multiple clicks don't result in multiple form submissions

      if (!purchaseLoading) {
        this.trackEventCollector('Manage Add Ons - Complete');

        localPurchaseAddOn({
          bundleId: versionedBundleId,
          successMessage: 'Success! Your add on credits have been added to your plan.'
        });
      }
    }
  }, {
    key: 'trackEventCollector',
    value: function trackEventCollector(name) {
      var _props2 = this.props,
          currentPlanId = _props2.currentPlanId,
          currentPlanCode = _props2.currentPlanCode,
          versionedBundleId = _props2.versionedBundleId;


      (0, _multitrack.ec)(name, {
        current_plan_id: currentPlanId,
        current_plan_code: currentPlanCode,
        modal_type: 'web_confirmation_modal',
        pending_add_on_id: versionedBundleId
      });
    }
  }, {
    key: 'render',
    value: function render() {
      var _props3 = this.props,
          purchaseError = _props3.purchaseError,
          bundleName = _props3.bundleName,
          strikeThroughPrice = _props3.strikeThroughPrice,
          strikeThroughPriceFractionalDigits = _props3.strikeThroughPriceFractionalDigits,
          currencyCode = _props3.currencyCode,
          price = _props3.price,
          priceFractionalDigits = _props3.priceFractionalDigits,
          hasTax = _props3.hasTax,
          subscriptionCycleEndDate = _props3.subscriptionCycleEndDate,
          purchaseLoading = _props3.purchaseLoading;


      return _react2.default.createElement(
        'div',
        { className: 'modal__body' },
        _react2.default.createElement(_ApiError.ApiError, {
          error: purchaseError,
          surfacedErrorCodes: [BUNDLE_PURCHASE_REQUEST_ERR_CODE, BUNDLE_PURCHASE_CARD_ERR_CODE]
        }),
        _react2.default.createElement(
          'h2',
          { className: 'mb' },
          _react2.default.createElement(_reactIntl.FormattedMessage, {
            id: 'classBundles.modal.title',
            defaultMessage: 'Review the details'
          })
        ),
        _react2.default.createElement(
          'p',
          null,
          _react2.default.createElement(_reactIntl.FormattedMessage, {
            id: 'classBundles.modal.credits.copy',
            defaultMessage: 'Your credits will be added to your account immediately'
          })
        ),
        _react2.default.createElement(
          'div',
          { className: 'mv p color-background-light' },
          _react2.default.createElement(
            'h3',
            null,
            _react2.default.createElement(_reactIntl.FormattedMessage, {
              id: 'classBundles.modal.bundleName',
              defaultMessage: '{name}',
              values: {
                name: bundleName
              }
            })
          ),
          _react2.default.createElement(
            'p',
            null,
            strikeThroughPrice && _react2.default.createElement(
              'del',
              { className: 'text--sm text--light' },
              _react2.default.createElement(_reactIntl.FormattedNumber, {
                value: strikeThroughPrice,
                style: 'currency',
                minimumFractionDigits: strikeThroughPriceFractionalDigits,
                maximumFractionDigits: strikeThroughPriceFractionalDigits,
                currency: currencyCode
              })
            ),
            '\xA0',
            _react2.default.createElement(
              'span',
              { className: 'text--lg' },
              _react2.default.createElement(_reactIntl.FormattedNumber, {
                value: price,
                style: 'currency',
                minimumFractionDigits: priceFractionalDigits,
                maximumFractionDigits: priceFractionalDigits,
                currency: currencyCode
              })
            ),
            hasTax && _react2.default.createElement(_reactIntl.FormattedMessage, {
              id: 'classBundles.modal.applicableTax',
              defaultMessage: ' + tax'
            })
          ),
          _react2.default.createElement(
            'p',
            { className: 'mh text--sm text--light' },
            _react2.default.createElement(_reactIntl.FormattedMessage, {
              id: 'classBundles.modal.credits.disclaimers',
              defaultMessage: 'Your month resets on {expirationDate}, at which point up to 10 credits will automatically roll over.{br}Credit purchases are a one-time charge and non-refundable.',
              values: {
                br: _react2.default.createElement('br', null),
                expirationDate: _react2.default.createElement(_reactIntl.FormattedDate, {
                  value: subscriptionCycleEndDate,
                  year: 'numeric',
                  month: 'long',
                  day: '2-digit',
                  timeZone: 'utc'
                })
              }
            })
          )
        ),
        _react2.default.createElement(
          'button',
          {
            disabled: purchaseLoading,
            onClick: this.handleClick,
            className: (0, _classnames2.default)('bt bt--primary bt--lg block sm-inline-block 1/1 sm-auto', {
              'btn--waiting': purchaseLoading
            })
          },
          _react2.default.createElement(_reactIntl.FormattedMessage, {
            id: 'classBundles.modal.cta',
            defaultMessage: 'Confirm purchase'
          })
        )
      );
    }
  }]);
  return ClassBundleModalUnwrapped;
}(_react2.default.Component);

ClassBundleModalUnwrapped.propTypes = {
  purchaseError: _propTypes2.default.object,
  purchaseLoading: _propTypes2.default.bool,
  versionedBundleId: _propTypes2.default.number.isRequired,
  currencyCode: _propTypes2.default.string.isRequired,
  price: _propTypes2.default.number.isRequired,
  priceFractionalDigits: _propTypes2.default.number.isRequired,
  strikeThroughPrice: _propTypes2.default.number,
  strikeThroughPriceFractionalDigits: _propTypes2.default.number.isRequired,
  hasTax: _propTypes2.default.bool.isRequired,
  subscriptionCycleEndDate: _propTypes2.default.string.isRequired,
  purchaseAddOn: _propTypes2.default.func.isRequired,
  currentPlanId: _propTypes2.default.number.isRequired,
  currentPlanCode: _propTypes2.default.string.isRequired,
  bundleName: _propTypes2.default.string.isRequired
};

var ClassBundleModal = exports.ClassBundleModal = (0, _Modal2.default)()((0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(ClassBundleModalUnwrapped));